import { footer } from '../../content/footer.js';

export function Footer() {
  return (
    <footer
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(54px,8vw,88px) clamp(18px,5vw,64px) 52px',
      }}
    >
      <div
        style={{
          borderTop: '1px solid var(--edge)',
          paddingTop: '28px',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '18px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            style={{
              width: '26px',
              height: '26px',
              borderRadius: '8px',
              background: 'var(--yellow)',
              display: 'grid',
              placeItems: 'center',
              flex: 'none',
            }}
          >
            <svg width="15" height="15" viewBox="0 0 512 512" aria-hidden="true">
              <g fill="#0B72C4">
                <path d="M272 122.67 L441.33 122.67 L381.07 214.67 L211.73 214.67 Z" />
                <path d="M129.33 206.67 L298.67 206.67 L238.4 298.67 L69.07 298.67 Z" />
                <path d="M213.33 296 L382.67 296 L322.4 388 L153.07 388 Z" />
              </g>
            </svg>
          </div>
          <span
            style={{
              font: "600 13px/1 'Plus Jakarta Sans',sans-serif",
              color: 'var(--muted)',
            }}
          >
            {footer.copyrightLine}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '22px',
            font: "600 13px/1 'Plus Jakarta Sans',sans-serif",
          }}
        >
          {footer.links.map((link) => (
            <a key={link.label} href={link.href} style={{ color: 'var(--muted)' }}>
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
